import React from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import PageHeader from "../components/PageHeader";
import Reveal from "../components/Reveal";
import CollectionCard from "../components/CollectionCard";
import LogoSlider from "../components/LogoSlider";
import Seo from "../components/Seo";
import { useI18n } from "../i18n";
import { useSiteData } from "../siteData";
import { SEO_META } from "../seo";

export default function ProductCategory() {
  const { key } = useParams();
  const { t, loc } = useI18n();
  const { collections, loading } = useSiteData();

  const parent = collections.find((c) => c.key === key);
  const children = collections.filter((c) => c.parent === key);
  const master = collections.find((c) => c.key === "match");
  const fallbackPdf = master?.pdf_url || "";
  const cards = children.length ? children : parent ? [parent] : [];

  if (!parent) {
    return (
      <div className="shell py-40 text-center">
        <p className="mono text-[10px] text-[#6B675F]">
          {loading ? "..." : t("portfolio.empty")}
        </p>
        <Link to="/products" className="mono text-[10px] link-underline mt-6 inline-block">
          {t("cta.allProducts")}
        </Link>
      </div>
    );
  }

  return (
    <div data-testid={`product-category-${key}`}>
      <Seo
        path={`/products/${key}`}
        title={`${parent.name} | ${loc(SEO_META.products.title)}`}
        description={loc(parent.character) || loc(SEO_META.products.description)}
        type="product"
      />
      <PageHeader
        index={`[ ${parent.no || "02"} // ${loc(parent.type).toUpperCase() || "PRODUCTS"} ]`}
        title={parent.name}
        lead={loc(parent.headline)}
      />

      <div className="border-b border-[#E2E0D8]">
        <div className="shell py-5">
          <Link
            to="/products"
            data-testid="category-back"
            className="mono text-[10px] text-[#141414] inline-flex items-center gap-2 link-underline"
          >
            <ArrowLeft size={13} strokeWidth={1.7} /> {t("cta.allProducts")}
          </Link>
        </div>
      </div>

      <section className="shell py-16 lg:py-24">
        <p className="mono text-[9.5px] text-[#6B675F] mb-10">
          {children.length ? t("products.collections") : t("products.gallery")} ({cards.length})
        </p>
        <div className="flex flex-col gap-6 lg:gap-8">
          {cards.map((c, i) => (
            <Reveal key={c.id} delay={(i % 2) * 70}>
              <CollectionCard item={c} index={i} fallbackPdf={fallbackPdf} />
            </Reveal>
          ))}
        </div>
      </section>

      <LogoSlider page="products" anchor="bottom" />
    </div>
  );
}
